<script>
	import './perlin.js';
	import {
		Button,
		ButtonGroup,
		Col,
		Row,
		Alert,
		Input,
		CustomInput,
		Label
	} from 'sveltestrap';
	import {
		onMount
	} from "svelte";

	let width = 800;
	let height = 588;
	var noisearray = new Array(width);
	var heatmap = new Array(width);
	var humiditymap = new Array(width);
	var a = 0.2;
	var b = 0.9;
	var c = 1.0;
	var threshold = 0.45;
	var start, end = null;
	var polustemp = -20;
	var equatortemp = 40;
	var generatebutton = true;
	var noisemap = true;
	var reliefmap = true;
	var rivermap = false;
	var drawriver = false;
	var drawriverstep = 0;
	var riverlength = 500;
	for (var i = 0; i < noisearray.length; i++) {
		noisearray[i] = new Array(height);
		heatmap[i] = new Array(height);
		humiditymap[i] = new Array(height);
	}
	var canvas = null;
	var data = null;
	let biomes = [
		// name, attitude range, temp range, humidity range, rgb
		['earth', -10, 10, -100, 100, -2000, 2000, 160, 136, 136],
		['snow', 0.9, 3, -50, 100, 30, 1500, 255, 255, 255],
		['bare', 0.9, 3, -50, 100, 10, 30, 180, 180, 180],
		['scorched', 0.9, 3, -50, 100, 0, 10, 143, 143, 143],
		['tundra', 0.03, 0.7, -50, -10, 0, 250, 200, 200, 255],
		['taiga', 0.03, 0.7, -10, 10, 0, 100, 147, 204, 176],
		['boreal forest', 0.03, 0.7, -10, 10, 100, 300, 155, 207, 168],
		['swamp', 0.03, 0.7, -10, 10, 300, 1500, 201, 212, 182],
		['desert', 0.03, 0.7, 10, 22, 0, 70, 240, 230, 140],
		['grassland', 0.03, 0.7, 10, 22, 70, 150, 201, 224, 159],
		['forest', 0.03, 0.7, 10, 22, 150, 300, 151, 201, 159],
		['rainforest', 0.03, 0.7, 10, 22, 300, 1500, 106, 206, 184],
		['subtropical desert', 0.03, 0.7, 22, 50, 0, 70, 174, 184, 154],
		['tropical forest', 0.03, 0.7, 22, 50, 100, 250, 127, 194, 126],
		['tropical rainforest', 0.03, 0.7, 22, 50, 250, 1500, 70, 153, 69],
		['mountain', 0.7, 0.9, -50, 100, 0, 150, 205, 133, 63],
		['grass mountain', 0.7, 0.9, -50, 100, 150, 1500, 151, 156, 106],
		['beach', 0, 0.03, 0, 50, 0, 1500, 255, 255, 0],
		['water', -0.3, 0, -50, 50, 0, 1500, 60, 60, 255],
		['deepwater', -3, -0.3, -50, 50, 0, 1500, 15, 13, 155],
		['snow', 0, 0.03, -50, 0, 0, 1500, 255, 255, 255],
		['snow', 0.03, 0.7, -50, -10, 250, 1500, 255, 255, 255],
		['grassland', 0.03, 0.7, 22, 50, 70, 100, 201, 224, 159],
	]

	let temps = [
		['coldest', -100, -10, 0, 0, 255],
		['colder', -10, 0, 135, 206, 235],
		['cold', 0, 10, 152, 251, 152],
		['warm', 10, 20, 255, 255, 0],
		['warmer', 20, 30, 255, 165, 0],
		['warmest', 30, 100, 255, 0, 0],
	]

	let humidity = [
		['dryest', -20, 40, 255, 0, 0],
		['dryer', 40, 70, 255, 165, 0],
		['dry', 70, 100, 255, 255, 0],
		['wet', 100, 150, 152, 251, 152],
		['weter', 150, 300, 135, 206, 235],
		['wetest', 300, 3000, 0, 0, 255],
	]

	function initCanvas() {
		canvas = document.getElementsByTagName('canvas')[0];
		canvas.width = width;
		canvas.height = height + 20;
	}

	function drawPixel(x, y, a, arrayset, thresh, border) {
		var index = (x + y * width) * 4;
		if (border) {
			arrayset.forEach(function(item) {
				if (a > item[1] + thresh && a <= item[2] + thresh) {
					if (heatmap[x][y] > item[3] && heatmap[x][y] <= item[4]) {
						if (humiditymap[x][y] > item[5] && humiditymap[x][y] <= item[6]) {
							for (let i = 0; i < 3; i++) {
								data[index + i] = item[i + 7];
								if (noisemap) {
									data[index + i] += Math.round(Math.random() * 15) - 5;
								}
								if (reliefmap) {
									data[index + i] -= Math.max(Math.round((noisearray[Math.max(0, x - 1)][Math.max(0, y - 1)] - noisearray[x][y]) * 500), 0);
								}
							}
						}
					}
				}
			});
			if (Math.round(a * 80) == Math.round((thresh) * 80)) {
				data[index + 0] = data[index + 1] = data[index + 2] = 0;
			}
		} else {
			arrayset.forEach(function(item) {
				if (a > item[1] + thresh && a <= item[2] + thresh) {
					for (let i = 0; i < 3; i++) {
						data[index + i] = item[i + 3];
					}
				}
			});
		}
		data[index + 3] = 256;
	}

	function generateMap() {
		noise.seed(Math.random());
		for (let y = 0; y < height; y++) {
			for (let x = 0; x < width; x++) {
				noisearray[x][y] = noise.perlin2(x / 60, y / 60) + 0.5;
				noisearray[x][y] += (noise.perlin2(x / 30, y / 30) + 0.5) * 0.5;
				noisearray[x][y] += (noise.perlin2(x / 10, y / 10) + 0.5) * 0.15;
				let nx = 2 * Math.abs(width / 2 - x) / width;
				let ny = 2 * Math.abs(height / 2 - y) / height;
				noisearray[x][y] = (noisearray[x][y] + a) * (1 - Math.pow(b * Math.sqrt(nx * nx + ny * ny), 2 - c));
			}
		}
		generateTemp();
		generateHumidity();
		if (rivermap) {
			generateRivers();
		}
		drawMap();
		generatebutton = true;
	}

	function generateTemp() {
		noise.seed(Math.random());
		for (let y = 0; y < height / 2; y++) {
			for (let x = 0; x < width; x++) {
				heatmap[x][y] = Math.round(2 * (polustemp * Math.abs(y - height / 2) + equatortemp * Math.abs(y)) / height);
			}
		}
		for (let y = height / 2; y < height; y++) {
			for (let x = 0; x < width; x++) {
				heatmap[x][y] = Math.round(2 * (polustemp * Math.abs(y - height / 2) + equatortemp * Math.abs(height - y)) / height);
			}
		}
		for (let y = 0; y < height; y++) {
			for (let x = 0; x < width; x++) {
				heatmap[x][y] += noise.perlin2(x / 200, y / 200) * 5;
				heatmap[x][y] -= Math.max(0, (noisearray[x][y] - threshold - 0.2) * 20) + Math.max(0, (noisearray[x][y] - threshold - 0.5) * 30);
				heatmap[x][y] += noise.perlin2(x / 30, y / 30) * 3;
			}
		}
	}

	function generateHumidity() {
		noise.seed(Math.random());
		for (let y = 0; y < height; y++) {
			for (let x = 0; x < width; x++) {
				humiditymap[x][y] = (noise.perlin2(x / 30, y / 30) + 0.5) * 100;
				humiditymap[x][y] += Math.max(0, (threshold + 0.15 - noisearray[x][y]) * 500) + Math.max(0, (threshold + 0.4 - noisearray[x][y]) * 300) + Math.max(0, (threshold + 0.7 - noisearray[x][y]) * 200);
				humiditymap[x][y] = Math.max(0, humiditymap[x][y]);
			}
		}
	}

	function generateRivers() {
		var pickX = 5 + Math.round(Math.random() * (width - 10));
		var pickY = 5 + Math.round(Math.random() * (height - 10));
		var attemp = 0;
		let maxiterations = Math.round(Math.random() * 1000);
		while (attemp < 1500 + maxiterations) {
			attemp++;
			if (noisearray[pickX][pickY] > 0.5 + threshold && noisearray[pickX][pickY] < 0.7 + threshold) {
				drawriver = false;
				drawriverstep = 0;
				createRiver(pickX, pickY);
			}
			pickX = 5 + Math.round(Math.random() * (width - 10));
			pickY = 5 + Math.round(Math.random() * (height - 10));
		}
	}

	function createRiver(riverx, rivery) {
		var newx = 0;
		var newy = 0;
		drawriverstep++;
		if (drawriverstep > riverlength) {
			return;
		}
		var newriveralt = noisearray[riverx][rivery];
		for (let y = -1; y < 2; y++) {
			for (let x = -1; x < 2; x++) {
				if (noisearray[riverx + x][rivery + y] < newriveralt && noisearray[riverx + x][rivery + y] > threshold - 0.03) {
					newriveralt = noisearray[riverx + x][rivery + y];
					newx = x;
					newy = y;
				}
			}
		}
		if (noisearray[riverx][rivery] < threshold && newx == 0 && newy == 0) {
			drawriver = true;
		}
		if (newx != 0 || newy != 0) {
			if (Math.random() < noisearray[riverx][rivery] - threshold) {
				createRiver(riverx + newx, rivery + newy);
			} else {
				createRiver(riverx + Math.round(Math.random() * 2 - 1), rivery + Math.round(Math.random() * 2 - 1));
			}
			if (Math.random() + 3 * (0.7 - noisearray[riverx][rivery] + threshold) > 0.7) {
				createRiver(riverx + Math.round(Math.random() * 2 - 1), rivery + Math.round(Math.random() * 2 - 1));
			}
			if (drawriver) {
				if (noisearray[riverx + newx - 1][rivery + newy - 1] - threshold > 0 && noisearray[riverx + newx - 1][rivery + newy - 1] - threshold < 0.1) {
					noisearray[riverx + newx - 1][rivery + newy - 1] = threshold + 0.025;
				}
				for (let y = -2; y < 3; y++) {
					for (let x = -2; x < 3; x++) {
						humiditymap[riverx + newx + x][rivery + newy + y] += Math.random() * (3 * Math.sqrt(Math.abs(x) * Math.abs(x) + Math.abs(y) * Math.abs(y)));
					}
				}
				noisearray[riverx + newx][rivery + newy] = threshold - 0.05;
			}
		}
	}

	function draw(type) {
		start = Date.now();
		var ctx = canvas.getContext('2d');
		var image = ctx.createImageData(canvas.width, canvas.height);
		data = image.data;
		if (type == 'map') {
			for (var x = 0; x < width; x++) {
				for (var y = 0; y < height; y++) {
					drawPixel(x, y, noisearray[x][y], biomes, threshold, true);
				}
			}
		}
		if (type == 'heat') {
			for (var x = 0; x < width; x++) {
				for (var y = 0; y < height; y++) {
					drawPixel(x, y, heatmap[x][y], temps, 0, false);
				}
			}
		}
		if (type == 'humidity') {
			for (var x = 0; x < width; x++) {
				for (var y = 0; y < height; y++) {
					drawPixel(x, y, humiditymap[x][y], humidity, 0, false);
				}
			}
		}
		end = Date.now();

		ctx.fillColor = 'black';
		ctx.fillRect(0, 0, width, height);
		ctx.putImageData(image, 0, 0);

		ctx.font = '16px sans-serif';
		ctx.textAlign = 'center';
		ctx.fillText('Rendered in ' + (end - start) + ' ms', canvas.width / 2, canvas.height - 2);
	}

	function drawMap() {
		draw('map');
	}

	function drawHeatMap() {
		draw('heat');
	}

	function drawHumidityMap() {
		draw('humidity');
	}

	function initAll() {
		initCanvas();
		generateMap();
	}

	function activateButton() {
		generatebutton = false;
	}

	onMount(initAll);
</script>

<svelte:head>
	<link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css">
</svelte:head>

<style>
	:global(body) {
		background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAADBElEQVRYhb2YS28TMRCAp5BCCw2U0hZo2lJaUgmBuCIkDnvNJZysKA/P2ruWb/kP+ekckgmO4+dm0++Udfwcz9MgpbyBFVrrtwAAiNjjnF+CwWQyeQctwTl/3dZcQZRSXxwLHtAPIcSRebCqqu7tOcqyfLDbELG3/pjP5y8BAIqi6Pg2whg7Nr+FEB/N8VrrcwCA8Xj8IXykJXVdn6X0o8X6yZ1XMMZeWAt+9vVFxFtH22PK2i6Je1ksFs+SOzuwDxVCCHHXdJGTWJ+qqrqNJt+e58r5B+lXXddfqY1z/sMYeD8ajb7tsvh0Or2m36QepJda60PnIJd0ckVtG1MrkAXGyLI8C3JHIRXRWp8rpdaSrarqqokBryHpMsaeU5ttsbQxm6IoOjELVUr5XZbtPFMUn1yH1vrQ5VqEEEeh8UKIO8bYyWAweBNbqxWm0+l+FirL8iHkeGOQnlGESsWnDjvjiqWOxa8BAGaz2SeApRrsxeJT8DpYA9OwUr1IY+q6PkPE3kYGkonpXlbfSUkHcM4v6Vp8mNLYy7XFHLB9uqdiQ1VS9CbVbeRKcRV7D6IdfbictFkOVFXVZYwd73K9QojTpmOdIOJ7u43qmVjESCXLF4eu1wzotiRms9k6ZTOLs1bhnK9zv9CpTMm5pIiIvxtvwhXcjQ0GS0RKbClZgJXCx4wqFoGCodLclDfD9UDGIqW8KYqiM5lM+gDL6w/dQJYK+KJCSk1ik1WZwaZOb3iGUF38FLiEklQJKqV+triJx5yrdLkzEEKcpkYN2634wqap06lqshUg7LQHEf8AAEgpL6itKIpOLLE0+xNKqawytQ2fmRU7fTVNrgE9Gb4UjoxCCNFnjHl9cyN29QJlWX5vay9BUowglOZvlZ1a61exCXd5VWgC7SlYr5DjlFJemMHfTPFNXHpFtYXTn61o/NTmIvWd2ncr9rt3FmZS4JJGyvOHmZqlgoi3KbU1APwP1CmbGQ6HXUT8m7shG1+JuY4+sbLSxH4Oi4VEWkRK+SswZ7BE+AfPRvXu5RZenQAAAABJRU5ErkJggg==);
	}

	#container {
		border-radius: 6px;
		background-color: moccasin;
		border: 1px solid black;
		overflow: hidden;
	}

	#container>canvas {
		height: 608px;
		background-color: moccasin;
	}

	#legend {
		border-radius: 6px;
		background-color: moccasin;
		border: 1px solid black;
		overflow: hidden;
		font-size: 10px;
	}
	td {
		cellpadding: 8;
		width: 80px;
		text-align: center;
	}
</style>
<div id="background">
	<Row>
		<Col sm="12" md={{ size: 6, offset: 2 }} style="min-width: 800px;max-width: 800px;">
		<div id="container">
			<canvas id="canvas"></canvas>
		</div>
		<p></p>
		<div id="legend">
			<table>
			  <tr>
			    <td bgcolor="#A08888">Earth</td>
			    <td bgcolor="#FFFFFF">Snow</td>
			    <td bgcolor="#B4B4B4">Bare</td>
					<td bgcolor="#8F8F8F" style="color:#ffffff">Scorched</td>
					<td bgcolor="#C8C8FF">Tundra</td>
					<td bgcolor="#93CCB0">Taiga</td>
					<td bgcolor="#9BCFA8">Boreal forest</td>
					<td bgcolor="#C9D4B6">Swamp</td>
					<td bgcolor="#F0E68C">Desert</td>
					<td bgcolor="#C9E09F">Grassland</td>
			  </tr>
			  <tr>
					<td bgcolor="#97C99F">Forest</td>
			    <td bgcolor="#6ACEB8">Rainforest</td>
			    <td bgcolor="#AEB89A" >Subtrop. desert</td>
					<td bgcolor="#7FC27E">Trop. forest</td>
					<td bgcolor="#469945">Trop. rainforest</td>
					<td bgcolor="#CD853F">Mountain</td>
					<td bgcolor="#9B9C6A">Mountain grass</td>
					<td bgcolor="#FFFF00">Beach</td>
					<td bgcolor="#3C3CFF">Water</td>
					<td bgcolor="#0D0D9B" style="color:#ffffff">Deep water</td>
			  </tr>
			</table>
		</div>
		</Col>
		<Col xs="2" style="min-width: 250px;">
		<Alert color="warning" Generation>
			<Input type="number" min="0" max="1" bind:value={a} step="0.1" on:change={activateButton} />
			<Label>Altitude growth</Label>
			<Input type="number" min="0" max="1" bind:value={b} step="0.1" on:change={activateButton} />
			<Label>Altitude decline</Label>
			<Input type="number" min="0" max="2" bind:value={c} step="0.1" on:change={activateButton} />
			<Label>Cliff</Label>
			<Input type="number" min="-40" max="50" bind:value={polustemp} step="1" on:change={activateButton} />
			<Label>Temp. at the poles</Label>
			<Input type="number" min="-40" max="50" bind:value={equatortemp} step="1" on:change={activateButton} />
			<Label>Temp. at the equator</Label>
			<Input type="number" min="0.25" max="2" bind:value={threshold} step="0.01" on:change={activateButton} />
			<Label>Ocean water level</Label>
			<Input type="number" min="200" max="1000" bind:value={riverlength} step="10" on:change={activateButton} />
			<Label>Maximum river length</Label>
			<CustomInput type="checkbox" label="Relief" id="reliefmap" inline bind:checked={reliefmap} />
			<CustomInput type="checkbox" label="Noise" inline id="noisemap" bind:checked={noisemap} />
			<CustomInput type="checkbox" label="Rivers" inline id="rivermap" bind:checked={rivermap} />
			<Button block color="primary" outline={generatebutton} on:click={generateMap}>Generate</Button>
			<p></p>
			<ButtonGroup>
				<Button size="sm" color="success" on:click={drawMap}>Biomes map</Button>
				<Button size="sm" color="danger" on:click={drawHeatMap}>Heat map</Button>
				<Button size="sm" color="primary" on:click={drawHumidityMap}>Humidity map</Button>
			</ButtonGroup>
		</Alert>
		</Col>

	</Row>
</div>
